import React from "react";

import { IconComponent } from "@app/core";
import VisibilityIcn from "@assets/icons/rounded/visibility.svg";
import VisibilityOffIcn from "@assets/icons/rounded/visibility-off.svg";
import { GetBannersExtendedStatusEnum } from "@app/api/generated";

interface IProps {
  status: string;
}

export const BannerStatusIcon = (props: IProps) => {
  if (props.status === GetBannersExtendedStatusEnum.VISIBLE) {
    return <IconComponent fillColor="#00A82F" icon={VisibilityIcn} size="18px" />;
  }

  if (props.status === GetBannersExtendedStatusEnum.INVISIBLE) {
    return <IconComponent fillColor="#E10A14" icon={VisibilityOffIcn} size="18px" />;
  }

  if (props.status === GetBannersExtendedStatusEnum.ALMOST_VISIBLE) {
    return <IconComponent fillColor="#FF8F00" icon={VisibilityOffIcn} size="18px" />;
  }

  return <IconComponent fillColor="#00A82F" icon={VisibilityIcn} size="18px" />;
};
